import { SecurityRoleTiny, SecurityRoleUtility, TaskSecurityRight, canModifySubmittedForm, getJobSectionRights, isJobTask } from '@jms/model';
import { TaskPermission } from './task.permission';

/**
 * Task actions on a web job: the Tasks module rights the job editors always asked for, AND the job's Tasks
 * section rights (never one without the other).
 */
export function jobTaskPermission(role: SecurityRoleTiny): TaskPermission {

    const has = (right: TaskSecurityRight) => SecurityRoleUtility.checkTinyRights(role, right);
    const tasks = getJobSectionRights(role).tasks;
    const manageRight = has(TaskSecurityRight.ManageManualTasks);

    return {
        viewOtherTask: has(TaskSecurityRight.ViewOtherTask),
        addTask: manageRight && tasks.create,
        editTask: manageRight && tasks.edit,
        manageTaskChecklists: has(TaskSecurityRight.ManageTaskChecklists) && tasks.edit,
        deleteAnyTasks: manageRight && has(TaskSecurityRight.DeleteAnyTasks) && tasks.delete,
        deleteMyTasks: manageRight && has(TaskSecurityRight.DeleteMyTasks) && tasks.delete,
    };
}

/**
 * The web app's rule for one task's Detail page (Tasks (new)). On a job task the fields and the status both need
 * Tasks › Edit as well as Manage Manual Tasks; other parents (opportunity, contact, site) follow the Tasks module
 * rights only. Without them the whole record locks, evidence included. A submitted form reopens with the Forms right.
 */
export function webTaskDetailRights(role: SecurityRoleTiny, task: { links?: { type?: string }[]; parent?: { type?: string } }): { canManage: boolean; canEditFields: boolean; canAddEvidence: boolean; canModifySubmittedForm: boolean } {

    const canManage = SecurityRoleUtility.checkTinyRights(role, TaskSecurityRight.ManageManualTasks) && (!isJobTask(task) || getJobSectionRights(role).tasks.edit);

    return { canManage, canEditFields: canManage, canAddEvidence: canManage, canModifySubmittedForm: SecurityRoleUtility.checkAllTinyRights(role, ...canModifySubmittedForm) };
}
